import { supabase } from '@/lib/supabase';
import type { BloodType, Gender, Profile } from '@/types/db';

export async function listProfiles(): Promise<Profile[]> {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .order('created_at', { ascending: true });
  if (error) throw error;
  return (data ?? []) as Profile[];
}

export async function getProfile(id: string): Promise<Profile | null> {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', id)
    .maybeSingle();
  if (error) throw error;
  return (data ?? null) as Profile | null;
}

export interface CreateProfileInput {
  name: string;
  relation: Profile['relation'];
  relation_other?: string | null;
  date_of_birth: string | null;
  allergies: string[];
  avatar_color: string | null;
  blood_type?: BloodType | null;
  weight_kg?: number | null;
  height_cm?: number | null;
  gender?: Gender | null;
}

export async function createProfile(
  _ownerId: string,
  input: CreateProfileInput,
): Promise<Profile> {
  const { data, error } = await supabase.rpc('create_profile', {
    p_name: input.name,
    p_relation: input.relation,
    p_date_of_birth: input.date_of_birth,
    p_allergies: input.allergies,
    p_avatar_color: input.avatar_color,
    p_blood_type: input.blood_type ?? null,
    p_weight_kg: input.weight_kg ?? null,
    p_height_cm: input.height_cm ?? null,
    p_gender: input.gender ?? null,
    p_relation_other: input.relation_other ?? null,
  });
  if (error) throw error;
  return data as Profile;
}

export interface UpdateProfileInput {
  name: string;
  relation: Profile['relation'];
  relation_other?: string | null;
  date_of_birth: string | null;
  allergies: string[];
  avatar_color: string | null;
  blood_type?: BloodType | null;
  weight_kg?: number | null;
  height_cm?: number | null;
  gender?: Gender | null;
}

export async function updateProfile(
  id: string,
  input: UpdateProfileInput,
): Promise<Profile> {
  const { data, error } = await supabase.rpc('update_profile', {
    p_id: id,
    p_name: input.name,
    p_relation: input.relation,
    p_date_of_birth: input.date_of_birth,
    p_allergies: input.allergies,
    p_avatar_color: input.avatar_color,
    p_blood_type: input.blood_type ?? null,
    p_weight_kg: input.weight_kg ?? null,
    p_height_cm: input.height_cm ?? null,
    p_gender: input.gender ?? null,
    p_relation_other: input.relation_other ?? null,
  });
  if (error) throw error;
  return data as Profile;
}

export async function deleteProfile(id: string): Promise<void> {
  const { error } = await supabase.from('profiles').delete().eq('id', id);
  if (error) throw error;
}
